/**
 * Constantes globais do Agendario Admin
 */

// Valores padrão para serviços
export const SERVICE_DEFAULTS = {
  DURATION_MINUTES: 30,
  MIN_DURATION: 15,
  MAX_DURATION: 480, // 8 horas
  DEFAULT_PRICE: 0,
  MIN_PRICE: 0,
  MAX_PRICE: 10000,
};

// Valores padrão para agendas
export const AGENDA_DEFAULTS = {
  AUTO_GENERATION_DAYS: 30,
  AVAILABLE_DAYS_RANGE: 7,
  MIN_AUTO_GENERATION: 7,
  MAX_AUTO_GENERATION: 90,
};

// Valores padrão para turnos (shifts)
export const SHIFT_DEFAULTS = {
  START_TIME: '09:00',
  END_TIME: '18:00',
  BREAK_BETWEEN_APPOINTMENTS: 0,
  MIN_BREAK: 0,
  MAX_BREAK: 60,
};

// Categorias de serviços
export const SERVICE_CATEGORIES = [
  'Beleza',
  'Estética',
  'Saúde',
  'Fitness',
  'Consultoria',
  'Educação',
  'Outro',
];

// Estados brasileiros
export const BRAZILIAN_STATES = [
  'AC', 'AL', 'AP', 'AM', 'BA', 'CE', 'DF', 'ES', 'GO', 'MA',
  'MT', 'MS', 'MG', 'PA', 'PB', 'PR', 'PE', 'PI', 'RJ', 'RN',
  'RS', 'RO', 'RR', 'SC', 'SP', 'SE', 'TO',
];

// Opções de gênero
export const GENDER_OPTIONS = [
  { value: 'M', label: 'Masculino' },
  { value: 'F', label: 'Feminino' },
  { value: 'O', label: 'Outro' },
  { value: 'N', label: 'Prefiro não informar' },
];

// Tipos de pagamento (sincronizado com backend)
export const PAYMENT_TYPES = {
  CASH: { value: 0, label: 'Dinheiro' },
  CREDIT_CARD: { value: 1, label: 'Cartão de Crédito' },
  DEBIT_CARD: { value: 2, label: 'Cartão de Débito' },
  PIX: { value: 3, label: 'PIX' },
  HEALTH_INSURANCE: { value: 4, label: 'Convênio de Saúde' },
  INSURANCE: { value: 5, label: 'Seguro' },
};

// Duração de snackbars (notificações)
export const SNACKBAR_DURATION = {
  SHORT: 2000,
  MEDIUM: 4000,
  LONG: 6000,
};

// Paginação
export const PAGINATION = {
  DEFAULT_PAGE_SIZE: 10,
  PAGE_SIZE_OPTIONS: [10, 25, 50, 100],
};

// Validação
export const VALIDATION = {
  MIN_NAME_LENGTH: 2,
  MAX_NAME_LENGTH: 100,
  MIN_DESCRIPTION_LENGTH: 0,
  MAX_DESCRIPTION_LENGTH: 500,
  PHONE_LENGTH: 11, // (99) 99999-9999 sem máscara
  CPF_LENGTH: 11,
  CEP_LENGTH: 8,
};

// API
export const API_TIMEOUTS = {
  DEFAULT: 30000, // 30 segundos
  UPLOAD: 120000, // 2 minutos
};

// Cores do sistema (sincronizado com MUI theme)
export const COLORS = {
  PRIMARY: '#1976d2',
  SECONDARY: '#dc004e',
  SUCCESS: '#4caf50',
  ERROR: '#f44336',
  WARNING: '#ff9800',
  INFO: '#2196f3',
};
